import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { FiltroDeclaracionJurada } from "../models/filtroDeclaracionJurada";
import { FileEndosoDto } from "../../../endosos/generacionmasiva/models/fileEndosoDto";

const generarDeclaracionJurada = async (e: FiltroDeclaracionJurada) : Promise<AxiosResponse<FileEndosoDto>> => {
    const response = await axiosInstance.post("siscred-api-reportes/v1/certificado-sii/declaracion-jurada", e);
    return response;
}

export { generarDeclaracionJurada }